/* Reseñas reales de producto: orden aleatorio en cada visita, carrusel con
   avance automático (pausable) + flechas, y un visor para ampliar fotos o
   reproducir el video sin salir de la página. */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function barajar(lista) {
    for (var i = lista.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = lista[i]; lista[i] = lista[j]; lista[j] = tmp;
    }
    return lista;
  }

  function initOrdenAleatorio() {
    var tracks = document.querySelectorAll('[data-resp-track]');
    Array.prototype.forEach.call(tracks, function (track) {
      var tarjetas = Array.prototype.slice.call(track.children);
      if (tarjetas.length < 2) return;
      barajar(tarjetas).forEach(function (tarjeta) { track.appendChild(tarjeta); });
    });
  }

  function initCarruseles() {
    var roots = document.querySelectorAll('[data-resp]');
    Array.prototype.forEach.call(roots, function (root) {
      var viewport = root.querySelector('[data-resp-viewport]');
      var track = root.querySelector('[data-resp-track]');
      var prev = root.querySelector('[data-resp-prev]');
      var next = root.querySelector('[data-resp-next]');
      if (!viewport || !track) return;
      var tarjetas = track.querySelectorAll('[data-resp-card]');
      if (!tarjetas.length) return;

      function pasoScroll() {
        var estilo = getComputedStyle(track);
        var gap = parseFloat(estilo.columnGap || estilo.gap) || 0;
        return tarjetas[0].getBoundingClientRect().width + gap;
      }

      function irA(direccion) {
        viewport.scrollBy({ left: pasoScroll() * direccion, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { pausar(); irA(-1); soltar(3000); });
      if (next) next.addEventListener('click', function () { pausar(); irA(1); soltar(3000); });

      if (tarjetas.length < 2 || reduceMotion) return;

      var pausado = false;
      var reanudar;
      function pausar() { pausado = true; clearTimeout(reanudar); }
      function soltar(espera) {
        clearTimeout(reanudar);
        reanudar = setTimeout(function () { pausado = false; }, espera);
      }

      var avance = setInterval(function () {
        if (pausado || !viewport.isConnected) return;
        var alFinal = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 4;
        if (alFinal) {
          viewport.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          irA(1);
        }
      }, 4200);

      // Si la sección se saca del DOM (edición en vivo del tema), no seguir corriendo.
      new MutationObserver(function () {
        if (!document.body.contains(viewport)) clearInterval(avance);
      }).observe(document.body, { childList: true, subtree: true });

      root.addEventListener('mouseenter', pausar);
      root.addEventListener('mouseleave', function () { soltar(300); });
      root.addEventListener('pointerdown', pausar);
      root.addEventListener('touchstart', pausar, { passive: true });
      ['pointerup', 'pointercancel', 'touchend'].forEach(function (ev) {
        root.addEventListener(ev, function () { soltar(2600); });
      });
    });
  }

  /* ---- Visor de fotos y video ---- */
  function initVisor() {
    var lightbox = document.querySelector('[data-resp-lightbox]');
    var stage = lightbox && lightbox.querySelector('[data-resp-stage]');
    if (!lightbox || !stage) return;

    function cerrar() {
      lightbox.hidden = true;
      stage.innerHTML = '';
      document.body.classList.remove('sm-resp-lb-open');
    }

    function abrir(tipo, src) {
      stage.innerHTML = '';
      var el;
      if (tipo === 'video') {
        el = document.createElement('video');
        el.src = src;
        el.controls = true;
        el.autoplay = true;
        el.playsInline = true;
      } else {
        el = document.createElement('img');
        el.src = src;
        el.alt = '';
      }
      stage.appendChild(el);
      lightbox.hidden = false;
      document.body.classList.add('sm-resp-lb-open');
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-resp-open]');
      if (btn) {
        abrir(btn.getAttribute('data-resp-type'), btn.getAttribute('data-resp-src'));
        return;
      }
      if (e.target.closest('[data-resp-close]')) cerrar();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lightbox.hidden) cerrar();
    });
  }

  function boot() {
    initOrdenAleatorio();
    initCarruseles();
    initVisor();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
